import React, { useState, useEffect } from "react";
import { Form, Input, Button, Row, Col, Typography, Modal, message, Spin } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import { SUBMISSION_FAILED } from "../../constants/constants";
import _NewapplicationService from "../../modules/NewapplicationService";
import CurrencyInput from "../../components/CurrencyInput";
import ShowApplicationId from "../NewApplication/ShowApplicationId";
import ApplicationProgressBar from "./ApplicationProgressBar";
import { LeftOutlined, RightOutlined,ArrowRightOutlined } from '@ant-design/icons';
import ButtonComponent from "../../components/Button/Button";


const { Title } = Typography;
const { confirm } = Modal;

const Expenses = () => {
    const [form] = Form.useForm();
    const history = useHistory();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [expenses, setExpenses] = useState({});
    const applicationId = localStorage.getItem("ApplicationId");


    const data = location.state || {};
    const appObjId = data?.applicationObjId || "";
    const isFromDashboard = data?.isFromDashboard || false;
    const tabActiveKey = data?.activeKey || null;

    // 🧠 Watch each field separately
    const watchedMortgage = Form.useWatch("mortgageorRentalPayments", form);
    const watchedLoan = Form.useWatch("loanPayments", form);
    const watchedPropertyTax = Form.useWatch("propertyTaxes", form);
    const watchedTaxes = Form.useWatch("taxes", form);
    const watchedInsurance = Form.useWatch("insurance", form);
    const watchedAlimony = Form.useWatch("alimony", form);
    const watchedLiving = Form.useWatch("livingExpenses", form);
    const watchedOther = Form.useWatch("otherExpense", form);
        useEffect(() => {
              window.scrollTo(0, 0);
            }, []);
    useEffect(() => {
        GetExpensesByApplicationID();
    }, []);

    useEffect(() => {
        form.resetFields();
    }, [expenses]);

    // Auto calculate total whenever any field changes
    useEffect(() => {
        const toNumber = (val) => {
            const num = parseFloat(val);
            return isNaN(num) ? 0 : num;
        };

        const total =
            toNumber(watchedMortgage) +
            toNumber(watchedLoan) +
            toNumber(watchedPropertyTax) +
            toNumber(watchedTaxes) +
            toNumber(watchedInsurance) +
            toNumber(watchedAlimony) +
            toNumber(watchedLiving) +
            toNumber(watchedOther);

        form.setFieldsValue({ total: total.toFixed(2) });
    }, [
        watchedMortgage,
        watchedLoan,
        watchedPropertyTax,
        watchedTaxes,
        watchedInsurance,
        watchedAlimony,
        watchedLiving,
        watchedOther,
        form,
    ]);

    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        } else {
            history.push(routes.incomeSources.path);
        }
    }
    const onNext = () => history.push(routes.balanceSheetAssets.path);

    const onFinish = async (values) => {
        if (values && parseFloat(values.total) <= 0) {
            message.error("Please enter an amount in at least one field (Total Expenses should not be 0)");
            return false;
        }

        setLoading(true);
        const reqObj = {
            ApplicationId: isFromDashboard ? appObjId : localStorage.getItem("Id"),
            IsExpensesCompleted: true,
            listexpences: [
                {
                    ApplicationId: isFromDashboard
                        ? appObjId
                        : localStorage.getItem("Id"),
                    MortgageOrRentalPayment: values.mortgageorRentalPayments,
                    LoanPayment: values.loanPayments,
                    PropertyTax: values.propertyTaxes,
                    Taxes: values.taxes,
                    InsurancePremium: values.insurance,
                    Aluminy_ChildSupport_Maintainance: values.alimony,
                    LivingExpenses: values.livingExpenses,
                    OtherExpenses: values.otherExpense,
                    ExpenseTotal: values.total,
                },
            ],
        };

        try {
            const res = await _NewapplicationService.addOrUpdateExpenses(reqObj);
            if (res.data?.IsSuccess) {
                message.success(res.data.Message);
                if (isFromDashboard) {
                    history.push({
                        pathname: routes.dashboard.path,
                        state: { appObjId, activeKey: tabActiveKey },
                    });
                } else {
                    history.push(routes.balanceSheetAssets.path);
                }
            } else {
                message.error(res.data?.Message || "Something went wrong.");
            }
        } catch (err) {
            message.error(err.message || SUBMISSION_FAILED);
        } finally {
            setLoading(false);
        }
    };

    const GetExpensesByApplicationID = async () => {
        try {
            setLoading(true);
            const Id = localStorage.getItem("Id");
            const res = await _NewapplicationService.getExpensesByApplicationID(
                isFromDashboard ? appObjId : Id
            );

            const resObj = res.data?.[0];
            if (resObj) {
                setExpenses({
                    mortgageorRentalPayments: resObj.MortgageOrRentalPayment,
                    loanPayments: resObj.LoanPayment,
                    propertyTaxes: resObj.PropertyTax,
                    taxes: resObj.Taxes,
                    insurance: resObj.InsurancePremium,
                    alimony: resObj.Aluminy_ChildSupport_Maintainance,
                    livingExpenses: resObj.LivingExpenses,
                    otherExpense: resObj.OtherExpenses,
                    total: resObj.ExpenseTotal,
                    Application_Status_Id: resObj.Application_Status_Id
                });
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading}>
            <LeftLayout>
                {/* {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                <div style={{
                    position: "absolute",
                    top: 5,
                    right: 20,
                    margin: 0,
                    zIndex: 1000,
                    maxWidth: "1000px",
                    padding: "8px 16px",
                }}>
                    <ApplicationProgressBar />
                    <Title level={3} style={{ margin: 0 }}>
                        <ShowApplicationId />
                    </Title>
                </div>
            )} */}
                <div>
                    {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                        <div>
                            <ApplicationProgressBar />
                            <Title level={5}>
                                {/* <ShowApplicationId /> */}
                            </Title>
                        </div>
                    )}
                </div>
                <div className="application-dark-page">
                    <div className="application-card">
                        <Row>
                            <Col span={24}>
                                <Title level={3}>
                                    Expenses
                                </Title>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onFinish}
                                    initialValues={expenses}
                                >
                                    <Form.Item
                                        label="Mortgage or Rental Payments (P&I)"
                                        name="mortgageorRentalPayments"
                                        className='w50'
                                        rules={[{ required: false, message: "Mortgage or Rental Payments (P&I) is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Mortgage or Rental Payments (P&I)" />
                                    </Form.Item>

                                    <Form.Item label="Loan Payments (Excluding Mortgages)" name="loanPayments" className='w50'
                                        rules={[{ required: false, message: "Loan Payments (Excluding Mortgages) is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Loan Payments (Excluding Mortgages)" />
                                    </Form.Item>

                                    <Form.Item label="Property Taxes/Assessments" name="propertyTaxes" className='w50'
                                        rules={[{ required: false, message: "Property Taxes/Assessments is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Property Taxes/Assessments" />
                                    </Form.Item>

                                    <Form.Item label="Taxes (City, State, Federal)" name="taxes" className='w50'
                                        rules={[{ required: false, message: "Taxes (City, State, Federal) is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Taxes (City, State, Federal)" />
                                    </Form.Item>

                                    <Form.Item label="Insurance Premiums" name="insurance" className='w50'
                                        rules={[{ required: false, message: "Insurance Premiums is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Insurance Premiums" />
                                    </Form.Item>

                                    <Form.Item
                                        label="Alimony, Child Support, Maintenance"
                                        name="alimony"
                                        className='w50'
                                        rules={[{ required: false, message: "Alimony, Child Support, Maintenance is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Alimony, Child Support, Maintenance" />
                                    </Form.Item>

                                    <Form.Item label="Living Expenses" name="livingExpenses" className='w50'
                                        rules={[{ required: false, message: "Living Expenses is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Living Expenses" />
                                    </Form.Item>

                                    <Form.Item label="Other Expense" name="otherExpense" className='w50'
                                        rules={[{ required: false, message: "Other Expense is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Other Expense" />
                                    </Form.Item>

                                    <Form.Item label="Total" name="total" className='w50'
                                        rules={[{ required: false, message: "Total is required" }]}
                                    >
                                        <CurrencyInput placeholder="Enter Total" disabled />
                                    </Form.Item>

                                    <Form.Item>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                gap: 16,
                                                marginTop: 20,
                                            }}
                                            className="w95"
                                        >
                                            <ButtonComponent
                                                type="default"
                                                onClick={onBack}
                                                text="Go Back"
                                            />

                                            <ButtonComponent
                                                type="primary"
                                                htmlType="submit"
                                                text={
                                                    <span>
                                                        Save And Proceed <ArrowRightOutlined />
                                                    </span>
                                                }
                                                // text="Save And Proceed"
                                                disabled={
                                                    !(
                                                        Object.keys(expenses || {}).length === 0 ||
                                                        [1,2,4,9].includes(expenses?.Application_Status_Id)
                                                    )
                                                }

                                            />
                                            {/*

                                   
                                   
                                        <Button
                                        type="primary"
                                        htmlType="submit"
                                        disabled={
                                            !(
                                                Object.keys(expenses || {}).length === 0 ||
                                                [1,2,4,9].includes(expenses?.Application_Status_Id)
                                            )
                                        }
                                    >
                                        Save And Proceed <RightOutlined />
                                    </Button>
                                    {/* <Button onClick={onNext} style={{ borderRadius: 24 }}>
                                        Next <RightOutlined />
                                    </Button> */}
                                        </div>
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                </div>
            </LeftLayout>
        </Spin>

    );
};

export default Expenses;
